import { PersonBus } from "./PersonBus";
import { CustomerLogoBus } from "./CustomerLogoBus";
import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { v_InventoryBus } from "./v_InventoryBus";
import { InventoryLocationXrefBus } from "./InventoryLocationXrefBus";
import { InventoryThresholdOverrideBus } from "./InventoryThresholdOverrideBus";
import { InventorySupplierXrefBus } from "./InventorySupplierXrefBus";
import { InventoryBus } from "./InventoryBus";
import { InventoryConsumablesBus } from "./InventoryConsumablesBus";
import { InventoryConsMatchesBus } from "./InventoryConsMatchesBus";
import { InventoryThresholdOverrideBranchBus } from "./InventoryThresholdOverrideBranchBus";
import { InventoryPartNbrsBus } from "./InventoryPartNbrsBus";

export class PricingProjectionDetail extends BaseBus
{
    constructor(data: PricingProjectionDetail) {
        super();
        if (data) {

            this.yearMonth = data.yearMonth;
            this.billingCode = data.billingCode;
            this.dispatchNumber = data.dispatchNumber;
            this.quantity = data.quantity;
            this.price = data.price;
            this.amount = data.amount;
            this.dispatchId = data.dispatchId;
            this.invoiceId = data.invoiceId;
            this.invoiceNumber = data.invoiceNumber;
            this.originalQuantity = data.originalQuantity;
            this.originalPrice = data.originalPrice;
            this.invoiceLineId = data.invoiceLineId;
            this.divisionName = data.divisionName;
            this.invoiceDate = new Date(data.invoiceDate);
       }
    }

    CID(): any {
        return this.invoiceDate;
    }
    setId(id: any) {
        this.invoiceDate = id;
    }
    initialize(data: PricingProjectionDetail) {
        super.initialize(data);

    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setBeforeSave() {
    }
    setCommon(userId: any, date: Date, companyId: any = null) {

    }

    dispatchNumber: string;
    invoiceNumber: string;
    dispatchId: string;
    invoiceId: string;
    invoiceLineId: string;
    billingCode: string;
    invoiceDate: Date;
    quantity: number;
    price: number;
    amount: number;
    yearMonth: string;
    skip: boolean;
    originalQuantity: number;
    originalPrice: number;
    percentOff: number;
    divisionName: string;
}
